'use strict';

function ChangeAddress() {
  var _this3 = this;

  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_AccountController];
  this._analytics = new Analytics();
  this._history = new History();

  this.init = function () {
    this._$node = $(this.node);

    /*
      If address is in pending state, re-direct them back to account settings (Not allowed to change address)
      
      Example scenario - User comes here and edits address, goes into
      pending state and is re-directed successfully (success callback)
       Then clicks back button in browser to come back to this screen again.
      
      Ref: https://mogofintech.atlassian.net/browse/ACCT-1050 (Pending Address)
    */

    if (this._hasAddressInPendingState()) {
      this._goToAccountSettings();
      return false;
    }

    /*
      If user already has address in new format, and goes to create address page, 
      send them to the update address page instead.
      
      Example scenario - User doesn't have address in new format, and (correctly) 
      goes to the create address page. On success, get re-directed (success callback)
       Then clicks back button in browser to come back to create address page again
      instead of update address page
       Ref: https://mogofintech.atlassian.net/browse/ACCT-596 (New format Address)
     */

    var currentUrl = window.location.pathname;
    var isOnCreateAddressPage = currentUrl === '/member/dashboard/account/change-address-create';

    if (isOnCreateAddressPage && this._hasAddressInNewFormat() === true) {
      this._sendToUpdateAddressPage();
      return false;
    }

    // Cache the form
    this._$form = this._$node.find('.changeAddress__form');

    // Province select
    this.selectedItem = document.querySelector('.textLabel');
    // Form inputs
    this._$formInputs = {
      address: this._$node.find('.js--form-address'),
      province: this._$node.find('.js--form-province'),
      streetNumber: this._$node.find('.js--form-street-number'),
      streetName: this._$node.find('.js--form-street-name'),
      city: this._$node.find('.js--form-city'),
      suite: this._$node.find('.js--form-suite'),
      country: this._$node.find('.js--form-country'),
      postalCode: this._$node.find('.js--form-postal-code'),
      submit: this._$node.find('.js--form-submit'),
      // Initially, only the address search field is visible
      // Once user searches for address, then the rest become
      // un-hidden
      hiddenField: this._$node.find('.hidden-address-field')
    };

    this._$typeField = this._$node.find('.js--form-type');
    this.poBoxMsg = this._$node.find('.js--po-box-msg');
    this._$cantFindAddressText = this._$node.find('.cant-find-address');
    this._$cantFindAddressLink = this._$cantFindAddressText.find('.cant-find-address-link');
    this._$canadaPostIdHiddenField = this._$node.find('.js--form-canada-post-id');
    this._$addressFieldsPrompt = this._$node.find('.address-fields-prompt');

    this._notification = $('#Notification');

    $('.changeAddress__form-wrapper').mogo().create('DynamicEditAddressForm', {
      _presenter: this.presenter,
      _product: 'MogoMember',
      _onSuccess: this._onEditAddress.bind(this)
    });
  };

  this.initAllReady = function () {
    this.analytics.pushEvent('virtual-page-view');
    // Needed to add custom validations to form action
    this._extendPresenter();
    // Must set hidden type field to residential. Type accepts `residential | shipping`
    this._$typeField.val('residential');
    this._setupCanadaPostAutocomplete();
    this._setupEventHandlers();
  };

  this._setupEventHandlers = function () {
    var _this = this;

    // Listener for if user clicks cant find address
    this._$cantFindAddressLink.click(function () {
      // Make the search address field blank
      _this._$formInputs.address.val('');
      _this._$formInputs.streetNumber.val('');
      _this._$formInputs.streetName.val('');
      _this._$formInputs.city.val('');
      _this._$formInputs.suite.val('');
      _this._$formInputs.postalCode.val('');
      _this.selectedItem.removeClass('selected-item');
      _this.selectedItem.innerHTML = 'Province';
      _this._$addressFieldsPrompt.removeClass('hide').text('Manually type your address');
      _this._$formInputs.hiddenField.removeClass('hide');
      _this._$formInputs.country.val('Canada');
    });

    // Click Submit
    this._$formInputs.submit.click(function () {
      var isFormFieldsHidden = _this._$formInputs.hiddenField.hasClass('hide');
      var isAddressSearchEmpty = !_this._$formInputs.address.val();
      // Only the address search field is visible (initial state)
      if (isAddressSearchEmpty && isFormFieldsHidden) {
        _this._$form.mogo().setErrorForValidationField('address', 'Please enter an address');
      } else {
        // ensure address field is empty when submitting
        _this._$formInputs.address.val('');
      }
    });
  };

  this._setupCanadaPostAutocomplete = function () {
    var _this2 = this;

    this.cpAutoComplete = new CanadaPostAutocomplete(this._$form);

    // Make the search address field blank
    this._$formInputs.address.val('');

    /*
      This attribute gets un-set at some point, so ensure this is set, needed for
      disabling chrome auto-complete overlapping canada post autocomplete 
      Ref:
        https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
        https://github.com/bcgov/entity/issues/661
    */
    this._$formInputs.address.attr('autocomplete', 'chrome-off');

    // When province changes, reset old validations
    // From previous potential postal code validation messages
    this._$formInputs.province.change(function () {
      _this2.cpAutoComplete.resetFormValidations();
    });

    // Listener for when inputs are filled out by CP
    this.cpAutoComplete.control.listen('populate', function (address) {
      _this2.cpAutoComplete.resetFormValidations();

      _this2._$formInputs.hiddenField.removeClass('hide');

      // Update select field to province provided by CP
      // CP doesn't fill out select html elements so need to do manually
      _this2._$formInputs.province.val(address.ProvinceCode).change();

      // If po box number present in CP address response
      // set street number as po box number
      // and street name as po box
      if (address.POBoxNumber && !address.BuildingNumber && !address.Street) {
        _this2._$formInputs.streetNumber.val(address.POBoxNumber);
        _this2._$formInputs.streetName.val('PO Box');
      }

      if (_this2._$formInputs.streetName.val() === 'PO Box') {
        // Show PO Box messaging in header
        _this2.poBoxMsg.removeClass('hide');
      } else {
        _this2.poBoxMsg.addClass('hide');
      }

      _this2.canadaPostID = address.Id;

      // Show hidden fields, update tet
      _this2._$addressFieldsPrompt.removeClass('hide').text('Confirm your address');
      _this2._$formInputs.hiddenField.removeClass('hide');

      // Clear address before serialize
      _this2._$formInputs.address.val('');

      // Serialize Form (Save all form values as string)
      // Using this string, set this.formValues var for comparison later
      _this2.formValues = _this2._$form.serialize();

      // Make the search address field update with the full formatted address
      _this2._$formInputs.address.val(address.FormattedLine1);
    });
  };

  this._extendPresenter = function () {
    var formAction = '';
    if (this._hasAddressInNewFormat() === true) {
      formAction = 'account.update_member_address';
    } else {
      formAction = 'account.create_member_address';
    }
    // Bind custom validations to the form action / ie when form is submit
    this.presenter.extendCustomValidations(formAction, {
      _hooks: {
        // Call this posthook method to trigger validation errors
        posthook: this._posthook.bind(this)
      },
      apartment: {
        sanitize: function sanitize(value) {
          if (value === undefined) {
            return '';
          }
          return value;
        }
      }
    });
  };

  // New format address  format - https://mogofintech.atlassian.net/browse/ACCT-596
  this._hasAddressInNewFormat = function () {
    var newAddressArray = _this3.presenter.getModelProperty('account.addresses');

    if (!newAddressArray) return false;

    var addressList = newAddressArray.filter(function (address) {
      return address.type === 'residential';
    });

    if (addressList && addressList.length > 0) {
      return true;
    }
    return false;
  };

  this._posthook = function () {
    var formValues = this._$form.serialize();
    var province = this._$formInputs.province.val();
    var postalCode = this._$formInputs.postalCode.val();
    var firstCharPostalCode = postalCode.charAt(0);
    var notEmpty = province && postalCode && this.cpAutoComplete.postalCodeMap[province];

    // Dont allow users to submit addresses from Quebec
    if (this._$formInputs.province.val() === 'QC') {
      this._$form.mogo().setErrorForValidationField('state_province', 'If you have moved to Quebec, please get in touch with us to update address.');
    } else if (notEmpty && !this.cpAutoComplete.postalCodeMap[province].firstLetter.includes(firstCharPostalCode)) {
      // Check if postal code is from selected province
      // Else throw validation error
      this._$form.mogo().setErrorForValidationField('postal_zip_code', "The postal code doesn't look to be from the province you have provided");
    }

    // If form values before submitting match what was filled out by
    // CP, then no changes were made, in this case , send in a
    // Canada_post_id to BE (add val to hidden canada_post_id field)
    // If changes were made (form values dont match), then don't send
    // Canada_post_id to BE.
    if (this.formValues === formValues) {
      this._$canadaPostIdHiddenField.val(this.canadaPostID);
    }

    this.presenter.extendViewMap({
      'account.apartment': {
        set: function set(val) {
          if (!val) return '';
          return val;
        }
      }
    });

    // remove address field
    delete this.presenter._viewMap['account.address'];
  };

  this._sendToUpdateAddressPage = function () {
    var updateAddressPage = '/member/dashboard/account/change-address-update';
    _this3._history.goToUrl(updateAddressPage);
  };

  this._onEditAddress = function () {
    this._history.goToUrl('/member/dashboard/account');
    this._notification.mogo().create({
      type: 'success',
      msg: 'Your address was successfully updated'
    });
  };

  this._hasAddressInPendingState = function () {
    return _this3.presenter.getModelProperty('account.pending_address');
  };

  this._goToAccountSettings = function () {
    _this3._history.goToUrl('/member/dashboard/account');
  };

  this._onCancel = function () {
    this.presenter.resetModels('account');
  };

  this._upcaseField = function (e) {
    return $(e.target).val($(e.target).val().toUpperCase());
  };

  this.destroy = function () {};
}